import { Component, Inject } from '@angular/core';
import { ApplicationStep } from "../nuvei-application-step";
import { DOCUMENT } from "@angular/common";

@Component({
  selector: 'app-nuvei-application-sales-profile',
  templateUrl: './nuvei-application-sales-profile.component.html',
  styleUrls: ['./nuvei-application-sales-profile.component.scss']
})
export class NuveiApplicationSalesProfileComponent extends ApplicationStep<'salesProfileForm'> {

  fieldExplanations = [
    { id: 'avgVolumePerMonth', title: 'Avg. Volume per Month', explanation: 'The estimated total dollar amount of sales your business processes each month.' },
    { id: 'avgTicketSize', title: 'Avg. Ticket Size', explanation: 'The average amount per individual transaction.' },
    { id: 'highTicket', title: 'High Ticket', explanation: 'The highest single transaction amount you project your business will process.' },
    { id: 'expectedAMEXPercentage', title: 'Expected Percentage of AMEX Transactions', explanation: 'The estimated share of your total sales expected to be paid with American Express.' },
  ];

  constructor(
      @Inject(DOCUMENT) protected document: Document,
  ) {
    super();
  }

}
